import bbitApi from '@api/make-request'
import {
  IPathParamsArgs,
  IRepository,
  numberArgs,
} from '@api/repositories/i-repository'
import { IEmployeeStatus } from '@app/interfaces/employee/employee-status'
import { AxiosResponse } from 'axios'

class EmployeeStatusRepository implements IRepository<IEmployeeStatus> {
  create(data: IEmployeeStatus): Promise<AxiosResponse<IEmployeeStatus>> {
    return bbitApi.post('/employee/api/v1/employee-status-dictionary', data)
  }

  getAll(args: IPathParamsArgs): Promise<AxiosResponse<IEmployeeStatus[]>> {
    return bbitApi.get('/employee/api/v1/employee-status-dictionary', {
      cancelToken: args.source?.token,
    })
  }

  getOne(args: numberArgs): Promise<AxiosResponse<IEmployeeStatus>> {
    return bbitApi.get(
      `/employee/api/v1/employee-status-dictionary/${args.data}`,
      { cancelToken: args.source?.token },
    )
  }

  update(data: IEmployeeStatus): Promise<AxiosResponse<IEmployeeStatus>> {
    return bbitApi.put(
      `/employee/api/v1/employee-status-dictionary/${data.id}`,
      data,
    )
  }
}

export default new EmployeeStatusRepository()
